import React, { useEffect, useState } from "react";
import './SurveyStart.scss';
import { useDispatch, useSelector } from "react-redux";
import { getUserSurveyAnswerAction, getSameSurveyAnswerAction } from "../redux/attemptSurvey/attemptSurvey.actions";
import Loader from "../loader/Loader";
import { Button, Modal } from 'react-bootstrap';
import AttemptedUserModal from "../components/Models/AttemptedUserModal";

const QuestionListing = ({ id, question }) => {
    const [answers, setAnswers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedSameAnswer, setSelectedSameAnswer] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const dispatch = useDispatch();
    const language = localStorage.getItem('language') || 'Italian';

    const texts = {
        Italian: {
            viewSameAnswers: "Visualizza risposte simili",
            sameAnswers: "Risposte simili",
            noSameAnswers: "Nessun utente ha la stessa risposta",
            question: "Domanda"
        },
        English: {
            viewSameAnswers: "View Same Answers",
            sameAnswers: "Same Answers",
            noSameAnswers: "No users have the same answer",
            question: "Question"
        }
    };

    useEffect(() => {
        getAllQuestionsWithAnswers();
    }, [id, dispatch, question]);

    const getAllQuestionsWithAnswers = async () => {
        try {
            const newAnswers = [];

            await Promise.all(question.map(async (q) => {
                const result = await dispatch(getUserSurveyAnswerAction(id, q._id));
                const sameAnswer = await dispatch(getSameSurveyAnswerAction(id, q._id));
                if (result && result.data && result.data.length > 0) {
                    newAnswers.push({
                        questionId: q._id,
                        answers: result.data.map(data => ({
                            answer: data.answer,
                            comment: data.comment,
                            userDetails: data.userDetails
                        })),
                        questionType: result.data[0].surveyQuestion?.questionsType?.type,
                        sameAnswer: sameAnswer?.data
                    });
                }
            }));
            console.log("newAnswers", newAnswers);

            setAnswers(newAnswers);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching answers:", error);
            setLoading(false);
        }
    };

    const getQuestionType = (questionId) => {
        const answerObj = answers.find(a => a.questionId === questionId);
        return answerObj?.questionType || "Single Choice";
    };

    const isOptionChecked = (questionId, option) => {
        const questionAnswers = answers.find(a => a.questionId === questionId)?.answers;
        if (!questionAnswers) return false;

        return questionAnswers.some(answer => {
            if (Array.isArray(answer.answer)) {
                return answer.answer.includes(option?._id);
            } else {
                return answer.answer === option?._id;
            }
        });
    };

    const getSelectedRating = (questionId) => {
        const questionAnswers = answers.find(a => a.questionId === questionId)?.answers;
        if (!questionAnswers) return 0;
        const q = Array.isArray(question) ? question.find(q => q._id === questionId) : null;
        if (!q || !Array.isArray(q.options)) return 0;
        const idToRating = new Map(q.options.map(opt => [String(opt._id), parseInt(opt.option, 10) || 0]));

        const ratings = questionAnswers.map(answer => {
            if (Array.isArray(answer.answer)) {
                const mapped = answer.answer.map(val => idToRating.get(String(val)) || 0);
                return mapped.length ? Math.max(...mapped) : 0;
            }
            return idToRating.get(String(answer.answer)) || 0;
        });

        return ratings.length ? Math.max(...ratings) : 0;
    };

    const isStarActive = (questionId, starValue) => {
        const q = Array.isArray(question) ? question.find(q => q._id === questionId) : null;
        if (!q || !Array.isArray(q.options)) return false;
        const idToRating = new Map(q.options.map(opt => [String(opt._id), parseInt(opt.option, 10) || 0]));
        const questionAnswers = answers.find(a => a.questionId === questionId)?.answers;
        if (!questionAnswers) return false;

        const maxSelected = questionAnswers.reduce((maxVal, answer) => {
            if (Array.isArray(answer.answer)) {
                const mapped = answer.answer.map(val => idToRating.get(String(val)) || 0);
                const localMax = mapped.length ? Math.max(...mapped) : 0;
                return Math.max(maxVal, localMax);
            }
            const single = idToRating.get(String(answer.answer)) || 0;
            return Math.max(maxVal, single);
        }, 0);

        return starValue <= maxSelected;
    };

    const getComments = (questionId) => {
        const questionAnswers = answers.find(a => a.questionId === questionId)?.answers;
        return questionAnswers ? questionAnswers.map(answer => answer.comment).filter(comment => comment) : [];
    };

    const getSameAnswer = (questionId) => {
        return answers.find(a => a.questionId === questionId)?.sameAnswer || null;
    };

    const openModal = (sameAnswer) => {
        setSelectedSameAnswer(sameAnswer);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const openUserDetailsModal = (user) => {
        setSelectedUser(user);
    };

    const closeUserDetailsModal = () => {
        setSelectedUser(null);
    };

    return (
        <div className="start_survey">
            {loading ? (
                <Loader />
            ) : (
                question && question.map((q, questionIndex) => {
                    const questionType = getQuestionType(q._id);
                    const isRating = questionType === "Rating";
                    const comments = getComments(q._id);
                    const sameAnswer = getSameAnswer(q._id);

                    return (
                        <div key={q._id} className="question_card">
                            <div className="question_count">
                                <div className="counts">
                                    <span>{questionIndex + 1}.
                                        <span className="question">{q.title}</span>
                                    </span>
                                </div>
                            </div>

                            {isRating ? (
                                <>
                                    <div className="star_wrapper" style={{ marginTop: "20px" }}>
                                        {[1, 2, 3, 4, 5].map((i) => (
                                            <div key={i} className={`star ${isStarActive(q._id, i) ? 'active' : ''}`}>
                                                <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M22.2699 2.96333L25.5943 9.61222C26.0477 10.5378 27.2566 11.4255 28.2766 11.5955L34.3021 12.5967C38.1554 13.2389 39.0621 16.0344 36.2854 18.7922L31.601 23.4767C30.8077 24.27 30.3732 25.8 30.6188 26.8955L31.9599 32.6944C33.0177 37.2844 30.581 39.06 26.5199 36.6611L20.8721 33.3178C19.8521 32.7133 18.171 32.7133 17.1321 33.3178L11.4843 36.6611C7.44211 39.06 4.98655 37.2656 6.04433 32.6944L7.38544 26.8955C7.631 25.8 7.19655 24.27 6.40322 23.4767L1.71877 18.7922C-1.039 16.0344 -0.151226 13.2389 3.70211 12.5967L9.72766 11.5955C10.7288 11.4255 11.9377 10.5378 12.391 9.61222L15.7154 2.96333C17.5288 -0.644452 20.4754 -0.644452 22.2699 2.96333Z" />
                                                </svg>
                                            </div>
                                        ))}
                                    </div>
                                    {comments.length > 0 && (
                                        <div className="comment_wrapper">
                                            {comments.map((comment, index) => (
                                                <textarea key={index}
                                                    value={comment}
                                                    disabled={true}
                                                    readOnly
                                                />
                                            ))}
                                        </div>
                                    )}
                                    <div className="same_answer_wrapper" style={{ display: 'flex', justifyContent: 'flex-start' }} onClick={() => openModal(sameAnswer)}>
                                        <div className="survey_show_result_btn pr-10"><img src="/images/survey/surveyIcon.png" alt="Calendar Icon" />{texts[language].viewSameAnswers}</div>
                                    </div>
                                </>
                            ) : (
                                <div className="option_wrapper">
                                    {q.options && q.options.map((option, index) => {
                                        const isChecked = isOptionChecked(q._id, option);
                                        const inputType = questionType === "Multiple Choice" ? "checkbox" : "radio";

                                        return (
                                            <div
                                                key={`multiple-${index}-${questionIndex}`}
                                                style={{
                                                    width: '100%',
                                                    margin: '0 0',
                                                    padding: '12px 0',
                                                    borderRadius: '8px',
                                                }}
                                            >
                                                <label
                                                    htmlFor={`option-${questionIndex}-${index}`}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        width: '100%',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    <div style={{
                                                        flex: '1',
                                                        fontSize: '16px',
                                                        fontWeight: isChecked ? '500' : 'normal'
                                                    }}>
                                                        {`${index + 1}. ${option?.option}`}
                                                    </div>

                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'flex-end'
                                                    }}>
                                                        <div style={{ marginLeft: '10px' }}>
                                                            <input
                                                                type={inputType}
                                                                id={`option-${questionIndex}-${index}`}
                                                                name={`question-${questionIndex}`}
                                                                value={option}
                                                                checked={isChecked}
                                                                disabled={true}
                                                                onChange={() => { }}
                                                                style={{
                                                                    width: '18px',
                                                                    height: '18px',
                                                                    cursor: 'pointer'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                        );
                                    })}
                                    {comments.length > 0 && (
                                        <div className="comment_wrapper">
                                            {comments.map((comment, index) => (
                                                <textarea key={index}
                                                    value={comment}
                                                    disabled={true}
                                                    readOnly
                                                />
                                            ))}
                                        </div>
                                    )}
                                    <div className="same_answer_wrapper" style={{ display: 'flex', justifyContent: 'flex-start' }} onClick={() => openModal(sameAnswer)}>
                                        <div className="survey_show_result_btn pr-10"><img src="/images/survey/surveyIcon.png" alt="Calendar Icon" />{texts[language].viewSameAnswers}</div>
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })
            )}
            <Modal show={modalIsOpen} onHide={closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{texts[language].sameAnswers}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedSameAnswer && selectedSameAnswer.length > 0 ? (
                        selectedSameAnswer.map((answer, index) => (
                            <div
                                key={index}
                                className="survey_winner_content mt-3"
                                onClick={() => openUserDetailsModal(answer.userDetails)}
                                style={{ cursor: 'pointer' }}
                            >
                                <img
                                    src={answer.userDetails.image ? `${process.env.REACT_APP_AWS_BUCKET_BASE_URL}${answer.userDetails.image}` : `${process.env.PUBLIC_URL}/images/no_profile.png`}
                                    alt="User"
                                />
                                <div>
                                    <span className="survey_winner_name">{answer.userDetails.name}</span>
                                    <span className="survey_winner_place">{answer.userDetails.country}</span>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div>{texts[language].noSameAnswers}</div>
                    )}
                </Modal.Body>
            </Modal>

            {selectedUser && (
                <AttemptedUserModal
                    user={selectedUser}
                    onHide={closeUserDetailsModal}
                />
            )}
        </div>
    );
};

export default QuestionListing;